<script setup>
import { ref, onMounted } from 'vue'
import Navbar from '@/components/navbar/navbar.vue'
import Footer from '@/components/footer/footer.vue'
import { useGeneralStore } from '@/store/general'
const { getDataEcommerce } = useGeneralStore()

const loading = ref(true)

onMounted(async () => {
  await getDataEcommerce() // Asegúrate de que getProducts se ejecute primero
  loading.value = false // Cambia el estado de loading una vez finalizada la ejecución
})
</script>
<template>
  <div>
    <!-- Start Hero -->
    <Navbar :navLight="true" :searMenu2="true" :tagLine="'tagline-height'" />
    <div v-if="!loading">
      <slot />
    </div>
    <Footer />
  </div>
</template>

<style lang="scss" scoped></style>
